import { POTENTIAL, COMPETENCES, MATURITY } from '@/model/rating/categories'

export default {
    [POTENTIAL]: {
        title: 'Potential',
        subtitle: 'How much potential does this trend hold for your company?',
        low: {
            title: 'low',
            subtitle: '',
            content:
      'Future innovations and developments for this trend are conceivable, ' +
      'but not yet identifiable for the chosen focus.'
        },
        moderate: {
            title: 'moderately',
            subtitle: '',
            content:
      'The trend offers discernible potential. The first developments in the focused business ' +
      'unit or product division can be observed.'
        },
        high: {
            title: 'high',
            subtitle: '',
            content:
      'The trend is establishing itself. The future potential is positive for the chosen focus, ' +
      'as promising developments are to be expected.'
        },
        epic: {
            title: 'very high',
            subtitle: '',
            content:
      'The trend offers a very high potential in the future. Possible applications and technologies ' +
      'of this trend can have a very large influence on the focused business unit or the product division.'
        }
    },
    [COMPETENCES]: {
        title: 'Compentences',
        subtitle: 'How well is your company prepared for this trend?',
        low: {
            title: 'Low',
            subtitle: '',
            content: 'The company hasn\'t been exploring the trend yet.'
        },
        moderate: {
            title: 'Moderate',
            subtitle: '',
            content: 'The company is already dealing with the trend at the pure knowledge level.'
        },
        high: {
            title: 'High',
            subtitle: '',
            content: 'First projects or measures, which support the trend, are being planned.'
        },
        epic: {
            title: 'Very high',
            subtitle: '',
            content: 'The trend is already reflected in concrete prototypes, services or processes.'
        }
    },
    [MATURITY]: {
        title: 'Maturity',
        subtitle: 'How mature is the trend?',

        epic: {
            title: 'Very high',
            subtitle: '(Late Majority)',
            content: 'Applications of this trend are directly implementable and have a high performance (Off the Shelf). The trend meets broad acceptance and has passed the tipping point.'
        },
        high: {
            title: 'High',
            subtitle: '(Early Majority)',
            content: 'The market around the applications and products of the trend establishes itself. Target group and clientele are growing.'
        },
        moderate: {
            title: 'Moderate',
            subtitle: '(Early Adopters)',
            content: 'The first products and services are introduced to the market and are purchased and tested by early adopters on both the corporate and consumer side. A suitable starting point for smart followers. '
        },
        low: {
            title: 'Low',
            subtitle: '(Innovators)',
            content: 'Technologies and applications of the trend are still in research or development. Fields of application are foreseeable, but still seem distant.'
        }
    }
}
